import CentralModal from "../../../../components/lib/centralModal";

const ConfirmActionModal = ({
    isOpen,
    onClose,
    selectedItems,
    selectedStudents,
    title,
    message,
    onConfirm,
    loading,
    confirmText = "Confirmar"
}) => {
    if (!isOpen) return null;

    const listToRender = selectedItems || selectedStudents || [];

    return (
        <CentralModal isOpen={isOpen} onClose={loading ? null : onClose} title={title}>
            <div className="p-4 w-full flex flex-col">
                <p className="mb-6 text-slate-600 text-sm text-center">
                    {message}
                </p>

                {listToRender.length > 0 && (
                    <div className="bg-slate-50 border rounded-md p-2 mb-4 max-h-40 overflow-y-auto text-sm">
                        <ul className="list-disc pl-5 text-slate-700">
                            {listToRender.map((item, index) => (
                                <li key={item.login || item.id || index}>
                                    {item.name || item.login}

                                    {item.grade && <span className="text-xs text-slate-400"> ({item.grade})</span>}
                                    {item.email && <span className="text-xs text-slate-400"> - {item.email}</span>}
                                </li>
                            ))}
                        </ul>
                    </div>
                )}

                <div className="flex justify-center gap-3 mt-2">
                    <button
                        onClick={onClose}
                        disabled={loading}
                        className="px-4 py-2 text-slate-500 hover:bg-slate-100 rounded-lg transition-colors disabled:opacity-50"
                    >
                        Cancelar
                    </button>
                    <button
                        onClick={onConfirm}
                        disabled={loading}
                        className="px-4 py-2 bg-custom_blue text-white rounded-lg hover:bg-blue-700 disabled:opacity-50 transition-colors flex items-center gap-2"
                    >
                        {loading && (
                            <svg className="animate-spin h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                                <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                            </svg>
                        )}
                        {loading ? "Processando..." : confirmText}
                    </button>
                </div>
            </div>
        </CentralModal>
    );
};

export default ConfirmActionModal;